module.exports = __webpack_public_path__ + "static/media/arrow-down.b5f40bd8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow-down.svg
// module id = 245
// module chunks = 0